import { Dispatch, SetStateAction } from "react";
import AboutLink from "../main/AboutLinks";

export default function AuthModal({
  iconSize,
  opened,
  setOpened,
}: {
  iconSize: number;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
}) {
  return (
    <>
      <AboutLink
        link={"login"}
        iconSize={iconSize}
        opened={opened}
        setOpened={setOpened}
      />
      <AboutLink
        link={"register"}
        iconSize={iconSize}
        opened={opened}
        setOpened={setOpened}
      />
    </>
  );
}
